import React, { useRef, useEffect, useState } from "react";
import { Chart, BarElement, CategoryScale, LinearScale, Tooltip } from "chart.js";
import { Bar } from "react-chartjs-2";

Chart.register(BarElement, CategoryScale, LinearScale, Tooltip);

const StatusBarChart = () => {
  const chartRef = useRef(null);
  const [chartData, setChartData] = useState({
  labels: ["Pending", "Completed", "Missing", "Failed"],
  datasets: [
    {
      label: "Status Count",
      data: [0, 0, 0, 0],
      backgroundColor: ["#ccc", "#ccc", "#ccc", "#ccc"],
    },
  ],
});

  useEffect(() => {
    const ctx = chartRef.current?.canvas.getContext("2d");
    if (!ctx) return;

    const gradientPending = ctx.createLinearGradient(0, 0, 0, 400);
    gradientPending.addColorStop(0, "rgba(252, 211, 77, 1)");
    gradientPending.addColorStop(1, "rgba(252, 211, 77, 0.2)");

    const gradientCompleted = ctx.createLinearGradient(0, 0, 0, 400);
    gradientCompleted.addColorStop(0, "rgba(16, 185, 129, 1)");
    gradientCompleted.addColorStop(1, "rgba(16, 185, 129, 0.2)");

    const gradientMissing = ctx.createLinearGradient(0, 0, 0, 400);
    gradientMissing.addColorStop(0, "rgba(239, 68, 68, 1)");
    gradientMissing.addColorStop(1, "rgba(239, 68, 68, 0.2)");

    const gradientFailed = ctx.createLinearGradient(0, 0, 0, 400);
    gradientFailed.addColorStop(0, "rgba(156, 163, 175, 1)");
    gradientFailed.addColorStop(1, "rgba(156, 163, 175, 0.2)");

    setChartData({
      labels: ["Pending", "Completed", "Missing", "Failed"],
      datasets: [
        {
          label: "Status Count",
          data: [25, 40, 12, 5],
          backgroundColor: [
            gradientPending,
            gradientCompleted,
            gradientMissing,
            gradientFailed,
          ],
          borderRadius: 0,
          borderSkipped: false,
        },
      ],
    });
  }, []);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#1f2937",
        titleColor: "#fff",
        bodyColor: "#e5e7eb",
        borderWidth: 1,
        borderColor: "#374151",
        padding: 10,
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          font: { size: 13, weight: "600" },
          color: "#111827",
        },
      },
      y: {
        beginAtZero: true,
        grid: { color: "rgba(0,0,0,0.1)", borderDash: [4, 4] },
        ticks: { stepSize: 10 },
      },
    },
  };
  
  return (
    <div style={{ height: "350px", width: "100%" }}>
      {chartData && <Bar ref={chartRef} data={chartData} options={options} />}
    </div>
  );
};

export default StatusBarChart;
